import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { Text } from "@src/appV2/redesign/system/ui-components";

const MIN_HEIGHT = "18.75rem";

interface ErrorStateProps {
  readonly onRetry: () => void;
}

export function ErrorState({ onRetry }: ErrorStateProps) {
  return (
    <Stack
      spacing={3}
      sx={(theme) => ({
        justifyContent: "center",
        alignItems: "center",
        minHeight: MIN_HEIGHT,
        padding: theme.spacing(4),
      })}
    >
      <Text
        variant="body1"
        sx={(theme) => ({ color: theme.palette.text.secondary, textAlign: "center" })}
      >
        Unable to load shift details. Please try again.
      </Text>
      <Button variant="outlined" onClick={onRetry}>
        Retry
      </Button>
    </Stack>
  );
}
